export const TRANSITION = 'transition';
export const EMAIL = 'email';
export const EXID = 'exid';
export const TEACHING = 'teaching';
export const SEMESTER = 'semester'; 
